export const keys = {
    storage: {
        columnSettingsStorage : 'mc-column-settings-storage-{layer_id}'
    }
};

export const AssetIdTypes = ['billboardId', 'junkyardId', 'brkey', 'hopApplicationId', 'hbmsPermitNumber', 'hopPermitNumber', 'projectId', 'tmsSiteNumber', 'tmsPermanentSiteId', 'hpmsSampleId', 'crossingId'];

export const AssetIdColumnMap = {
    billboardId: 'SIGN_APPL_ID',
    junkyardId: 'LICENSE_NUMBER',
    brkey: 'BRKEY',
    hopApplicationId: 'APPLICATION_ID',
    hopPermitNumber: 'PERMIT_NUM',
    hbmsPermitNumber: 'PERMIT_NUMBER',
    projectId: 'PROJECT_ID',
    tmsSiteNumber: 'TMS_SITE_NO',
    tmsPermanentSiteId: 'PERMANENT_SITE_ID',
    hpmsSampleId: 'HPMS_SAMP_SECT_NO',
    crossingId: 'CROSSING'
};
